<template>
  <WCCheckoutStage
    @checkout="$emit('checkout', $event)"
    :activeStage="activeStage"
    :stage="1"
    label="2. Customer Information"
  >
    <WCSpinner v-if="isSyncing" class="mx-auto align-self-center" size="xl" />
    <WCCustomerInfoForm
      v-else
      @continue="$emit('checkout')"
      @goback="$emit('goback')"
      @form-changed="
        setBilling($event);
        $emit('set-dirty', true);
      "
      @update:valid="$emit('update:valid', $event)"
      :billing="billing"
    />
  </WCCheckoutStage>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import WCCheckoutStage from '../WCCheckoutStage/WCCheckoutStage.vue';
import WCCustomerInfoForm from '../WCCustomerInfoForm/WCCustomerInfoForm.vue';

export default {
  components: { WCCheckoutStage, WCCustomerInfoForm, WCSpinner },
  props: {
    billing: {
      type: Object,
    },
    activeStage: {
      type: Number,
      required: true,
    },
  },
  methods: {
    ...mapMutations({ setBilling: 'cart/SET_BILLING' }),
  },
  computed: {
    ...mapGetters({
      isSyncing: 'cart/isSyncing',
    }),
  },
};
</script>

<style lang="scss" scoped></style>
